module.exports = __webpack_public_path__ + "static/media/yandexLogo_Dark1.3d33431c.svg";